var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
export var encodeIdInWrapper = function (commandId, TypeRequest, wrapper) {
    var protoMessage = TypeRequest.create(__assign({}, wrapper, { commandId: commandId }));
    var protoBuffer = TypeRequest.encode(protoMessage).finish();
    return new Uint8Array(protoBuffer);
};



//////////////////
// WEBPACK FOOTER
// ./src/utils/network/encoder/encodeIdInWrapper.ts
// module id = 2988
// module chunks = 3